import { render } from "./detail_page.vue?vue&type=template&id=c5639bd0&scoped=true"
import script from "./detail_page.vue?vue&type=script&lang=jsx"
export * from "./detail_page.vue?vue&type=script&lang=jsx"

import "./detail_page.vue?vue&type=style&index=0&id=c5639bd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5639bd0"]])

export default __exports__